import { acceptedProjectProcessFail, acceptedProjectProcessSuccess, deleteProjectProcessFail, deleteProjectProcessSuccess, getGppByGpIdFail, getGppByGpIdSuccess, getListProjectProcessEngFail, getListProjectProcessEngSuccess, getProjectProcessEngFail, getProjectProcessEngSuccess, projectProcessFail, projectProcessSuccess } from "./actions";
import { ACCEPTED_PROJECT_PROCESS, DEL_PROJECT_PROCESS, GET_GPP_BYGPID, GET_LIST_PROJECT_PROCESS_ENG, GET_LIST_PROJECT_PROCESS_REPORT, GET_PROJECT_PROCESS_ENG, PROJECT_PROCESS } from "./actionTypes";

import { acceptedProjectProcessApi, deleteProjectProcessApi, getGppById, getListProjectProcessEngApi, getListProjectProcessReportApi, projectProcessApi } from "helpers/backend_helper";

import { takeEvery, put, call } from "redux-saga/effects"


function* onGetGppByGpId({ payload: gpId }){
    try {
        const response = yield call(getGppById, gpId)
        yield put(getGppByGpIdSuccess(response))
    } catch (error) {
        yield put(getGppByGpIdFail(error))
    }
}

function* onProjectProcess({ payload: values }){
    try {
        const response = yield call(projectProcessApi, values)
        yield put(projectProcessSuccess())
    } catch (error) {
        yield put(projectProcessFail(error))
    }
}

function* onGetListProjectProcessEng({ payload: values }) {
    try {
      const response = yield call(getListProjectProcessEngApi,values)
      
      yield put(getListProjectProcessEngSuccess(response))
    } catch (error) {
      yield put(getListProjectProcessEngFail(error))
    }
}

function* onGetProjectProcessEng({ payload: values }) {
    try {
      const response = yield call(getListProjectProcessEngApi,values)
      
      yield put(getProjectProcessEngSuccess(response))
    } catch (error) {
      yield put(getProjectProcessEngFail(error))
    }
}

function* onGetListProjectProcessReport({ payload: values }) {
    try {
      const response = yield call(getListProjectProcessReportApi,values)
      
      yield put(getListProjectProcessEngSuccess(response))
    } catch (error) {
      yield put(getListProjectProcessEngFail(error))
    }
}

function* onDeleteProjectProcess({ payload: gppId }){
    try {
        const response = yield call(deleteProjectProcessApi, gppId)
        yield put(deleteProjectProcessSuccess(response))
    } catch (error) {
        yield put(deleteProjectProcessFail(error))
    }
}

function* onAcceptedProjectProcess({ payload: values }) {
    try {
        const response = yield call(acceptedProjectProcessApi, values)
        yield put(acceptedProjectProcessSuccess(response))
    } catch (error) {
        yield put(acceptedProjectProcessFail(error))
    }
}

function* gasProjectProcessesSaga(){
    yield takeEvery(GET_GPP_BYGPID,onGetGppByGpId)
    yield takeEvery(PROJECT_PROCESS,onProjectProcess)
    yield takeEvery(GET_LIST_PROJECT_PROCESS_ENG,onGetListProjectProcessEng)
    yield takeEvery(GET_LIST_PROJECT_PROCESS_REPORT,onGetListProjectProcessReport)
    yield takeEvery(DEL_PROJECT_PROCESS,onDeleteProjectProcess)
    yield takeEvery(GET_PROJECT_PROCESS_ENG,onGetProjectProcessEng)
    yield takeEvery(ACCEPTED_PROJECT_PROCESS,onAcceptedProjectProcess)



}

export default gasProjectProcessesSaga